import { Briefcase, Plus } from "lucide-react";

export default function EmptyState({ onCreate }) {
  return (
    <div className="rounded-sm border border-dashed border-slate-200 p-10 text-center bg-white" data-testid="deals-empty">
      <Briefcase className="w-10 h-10 text-slate-300 mx-auto" />
      <h3 className="mt-3 text-lg font-semibold text-slate-700">No deals yet</h3>
      <p className="text-sm text-slate-500 mt-1">Package your first opportunity and send it to your investor list.</p>
      <button onClick={onCreate}
        className="mt-5 inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-5 py-2.5 rounded-sm text-sm font-mono uppercase tracking-widest">
        <Plus className="w-4 h-4" /> Create First Deal
      </button>
    </div>
  );
}
